<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
    overlay-opacity="0.85"
    content-class="modern-agency-dialog"
  >
    <v-card class="rounded-xl" elevation="16">
      <!-- Header with gradient background -->
      <v-card-title
        class="editor-header d-flex justify-space-between align-center px-6 py-4"
      >
        <div class="text-h5 font-weight-bold white--text">
          <v-icon large color="white" class="mr-3">mdi-calendar-clock</v-icon>
          Availability
        </div>
        <v-btn
          icon
          @click="onClose"
          class="close-btn"
          color="white"
          depressed
          large
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Help text -->
      <v-card-text class="px-6 pt-5 pb-1 text-body-1 text--secondary">
        <div class="d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-information-outline</v-icon>
          What days and times you are available
        </div>
      </v-card-text>

      <!-- Error/Success message with smooth transition -->
      <v-expand-transition>
        <v-card-text class="px-6 py-0" v-if="message">
          <v-alert
            type="error"
            class="mb-4 elevation-2"
            transition="scale-transition"
            icon="mdi-alert-circle"
          >
            {{ message }}
          </v-alert>
        </v-card-text>
      </v-expand-transition>

      <!-- Main content -->
      <v-card-text class="px-6 py-2">
        <v-data-table
          :headers="headers"
          :items="data"
          :loading="loading"
          class="elevation-0 modern-table"
          hide-default-footer
        >
          <template v-slot:[`item.morning`]="{ item }">
            <div class="d-flex justify-center">
              <v-checkbox
                v-model="item.morning"
                @change="onUpdateValue(item, 'morning')"
                color="primary"
              />
            </div>
          </template>
          <template v-slot:[`item.afternoon`]="{ item }">
            <div class="d-flex justify-center">
              <v-checkbox
                v-model="item.afternoon"
                @change="onUpdateValue(item, 'afternoon')"
                color="primary"
              />
            </div>
          </template>
          <template v-slot:[`item.evening`]="{ item }">
            <div class="d-flex justify-center">
              <v-checkbox
                v-model="item.evening"
                @change="onUpdateValue(item, 'evening')"
                color="primary"
              />
            </div>
          </template>
          <template v-slot:[`item.nothing`]="{ item }">
            <div class="d-flex justify-center">
              <v-checkbox
                v-model="item.nothing"
                @change="onUpdateValue(item, 'nothing')"
                color="primary"
              />
            </div>
          </template>
        </v-data-table>
      </v-card-text>

      <!-- Action buttons -->
      <v-card-actions class="px-6 pb-6 pt-4 d-flex justify-center">
        <v-btn
          color="primary"
          @click="onSave"
          depressed
          width="200"
          :loading="loading"
          class="px-6 save-btn"
          large
          dark
        >
          <template v-slot:loader>
            <span class="custom-loader">
              <v-icon light>mdi-autorenew</v-icon>
            </span>
          </template>
          <v-icon left>mdi-content-save</v-icon>
          Save Availability
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    onClose: {
      type: Function
    }
  },
  data() {
    return {
      message: null,
      loading: false,
      headers: [
        { text: "", value: "day", sortable: false },
        { text: "Morning", value: "morning", sortable: false, align: "center" },
        {
          text: "Afternoon",
          value: "afternoon",
          sortable: false,
          align: "center"
        },
        { text: "Evening", value: "evening", sortable: false, align: "center" },
        {
          text: "Don't schedule me",
          value: "nothing",
          sortable: false,
          align: "center"
        }
      ],
      data: [
        {
          day: "Mon",
          morning: false,
          afternoon: false,
          evening: false,
          nothing: false
        },
        {
          day: "Tue",
          morning: false,
          afternoon: false,
          evening: false,
          nothing: false
        },
        {
          day: "Wed",
          morning: false,
          afternoon: false,
          evening: false,
          nothing: false
        },
        {
          day: "Thu",
          morning: false,
          afternoon: false,
          evening: false,
          nothing: false
        },
        {
          day: "Fri",
          morning: false,
          afternoon: false,
          evening: false,
          nothing: false
        },
        {
          day: "Sat",
          morning: false,
          afternoon: false,
          evening: false,
          nothing: false
        },
        {
          day: "Sun",
          morning: false,
          afternoon: false,
          evening: false,
          nothing: false
        }
      ]
    };
  },
  methods: {
    ...mapActions("auth", {
      updateProfile: "updateProfile"
    }),
    onUpdateValue(item, key) {
      console.log(item);
      this.message = null;
      if (key == "nothing" && item[key]) {
        item.morning = false;
        item.afternoon = false;
        item.evening = false;
      } else if (item[key]) {
        item.nothing = false;
      }
    },
    onSave() {
      let ok = false;
      let data = [];
      for (let i = 0; i < this.data.length; i++) {
        if (
          this.data[i].morning ||
          this.data[i].afternoon ||
          this.data[i].evening
        ) {
          ok = true;
          data.push(this.data[i]);
        } else if (this.data[i].nothing) {
          data.push(this.data[i]);
        }
      }
      if (!ok) {
        this.message = "Please select at least one.";
        return;
      }
      this.loading = true;
      this.updateProfile({ availabilities: data })
        .then(() => {
          this.loading = false;
          this.onClose();
        })
        .catch(error => {
          this.loading = false;
          this.message = error.response.data.message;
        });
    }
  },
  computed: {
    ...mapState("auth", {
      profile: "profile"
    })
  }
};
</script>
<style scoped>
.modern-agency-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.editor-header {
  background: linear-gradient(135deg, #3b7ca1 0%, #084468 100%);
}

.close-btn {
  transition: all 0.3s ease;
}

.close-btn:hover {
  transform: rotate(90deg);
  background: rgba(255, 255, 255, 0.2) !important;
}

.save-btn {
  box-shadow: 0 4px 12px rgba(58, 123, 213, 0.3) !important;
  transition: all 0.3s ease;
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(58, 123, 213, 0.4) !important;
}

.save-btn:active {
  transform: translateY(0);
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Table styling */
.modern-table::v-deep .v-data-table-header th {
  font-weight: 600;
  font-size: 0.9rem;
  color: var(--v-primary-base);
}

.modern-table::v-deep .v-data-table td {
  font-size: 0.9rem;
}

/* Scrollbar styling */
.modern-agency-dialog::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.modern-agency-dialog::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.modern-agency-dialog::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #3b7ca1 0%, #084468 100%);
  border-radius: 10px;
}

.modern-agency-dialog::-webkit-scrollbar-thumb:hover {
  background: #3a7bd5;
}
</style>